import { useEffect, useState } from "react";

const KEY = "svk_lang";

export function useLang(defaultLang = "sv") {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem(KEY) || defaultLang;
  });

  useEffect(() => {
    localStorage.setItem(KEY, lang);
  }, [lang]);

  return [lang, setLang];
}